import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function LeadsPage() {
  return <InstituteCrudPage config={entityConfigs['leads']} />;
}
